namespace advisorop.components.advisor {

    export class AppTrackerSummaryAdvisorController {
        // original data arrays
        newAccountLC: domains.IAppTrackerData[] = [];
        public proposedValue: number = 0;

        public filterByAdvisor = 1;
        // loading panel indicator
        loading = true;

        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#accountPipeline" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading...",
            bindingOptions: {
                visible: "vm.loading"
            }
        };

        static $inject = ["appTrackerApi", "generalService", "advisorService", "$rootScope"];
        constructor(private apt: advisorop.services.AppTrackerApi,
            private gs: advisorop.services.GeneralService,
            private as: advisorop.services.AdvisorService,
            private $rootScope: ng.IRootScopeService) {

            this.setFilterByAdvisor();

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.setFilterByAdvisor();
                this.loadNewAccountLifeCycle();
            }); 
        }

        setFilterByAdvisor() {
            const adminMode = this.as.getAdminMode();
            this.filterByAdvisor = (adminMode && adminMode.enabled) ? 0 : 1;
        }

        loadNewAccountLifeCycle() {
            this.loading = true;
            this.apt.getAppTrackerData(services.AppTrackerApi.LIFECYCLE_NEW_ACCOUNT, false, (this.filterByAdvisor == 1), true)
                .then(
                    resp => {
                        this.newAccountLC = resp.data;
                        if (this.newAccountLC.length > 0) {
                            this.proposedValue = this.newAccountLC.reduce(function (prev, cur) {
                                let x = prev + cur.proposedAmount;
                                return x
                            }, 0);
                        }
                    },
                    err => this.gs.showError(err))
                .finally(() => this.loading = false);
        }

        $onInit(): void {
            this.loadNewAccountLifeCycle();
        }
    }

    class AppTrackerSummaryAdvisor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {};
            this.controller = AppTrackerSummaryAdvisorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/app-tracker-summary-advisor.html";
        }
    }
    angular.module(Constants.APP).component("appTrackerSummaryAdvisor", new AppTrackerSummaryAdvisor());
}